export default __webpack_public_path__ + "static/media/winner.5e18a4f7.mp3";